import script from "./OnboardingAiBillingStep.vue?vue&type=script&setup=true&lang=js"
export * from "./OnboardingAiBillingStep.vue?vue&type=script&setup=true&lang=js"

import "./OnboardingAiBillingStep.vue?vue&type=style&index=0&id=40bb4fe2&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40bb4fe2"]])

export default __exports__